import type { IFormOfferings } from 'legacy/lut/classes/models/partner360/IFormOfferings'

import { ActualsValueTypes } from '../models/actualValueTypes'

/** Older offering payloads omit the screen default; keep their PDF default as a fallback. */
export const getOfferingActualsValueTypeDefault = (
  offering?: Pick<IFormOfferings, 'ActualsValueTypeDefault' | 'PDFActualsValueTypeDefault'>
): ActualsValueTypes =>
  (offering?.ActualsValueTypeDefault ||
    offering?.PDFActualsValueTypeDefault ||
    ActualsValueTypes.None) as ActualsValueTypes
